import React from 'react';

import Canvas from '../canvas/Canvas.js';
//import Astral from '../astral/Astral.js';

import './Main.css';

function Main(props) {

    return(
    	<div className="main-class">
            <Canvas /> :
	    <div className="ghost-circle"></div>
	</div>
    );
}

export default Main;
